import { Controller } from "@hotwired/stimulus"
import LassoDataTable from "../helpers/lasso_data_table"

export default class extends Controller {
  static get targets() { return ["table", "searchInput"] }

  // LassoDataTable wraps the DataTables jQuery plugin; the element it manages stays
  // jQuery-wrapped because the plugin's own API is what announces on it.
  connect() {
    this.contactsDatatable = new LassoDataTable($(this.tableTarget), {
      "order": [[1, "asc"]],
      "columns": [
        {"data": "id", "searchable": false, "orderable": false, "className": "hidden"},
        {"data": "email", "searchable": true, "orderable": true},
        {"data": "first_name", "searchable": true, "orderable": true},
        {"data": "last_name", "searchable": true, "orderable": true},
        {"data": "created_at", "searchable": false, "orderable": true},
      ]
    })
  }

  disconnect() {
    this.contactsDatatable.destroy()
  }

  search() {
    this.contactsDatatable.dataTable.api().search(this.searchInputTarget.value).draw()
  }
}
